module.exports = __webpack_public_path__ + "static/media/text-ru.55dd8927.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/lucky-chiken/text-ru.png
// module id = 2470
// module chunks = 7